module.exports = __webpack_public_path__ + "static/media/kv-trophy.55defa27.svg";